<template>
  <div class="dashboard has-background-black has-text-white p-2">
    <div class="fixed-grid has-4-cols">
      <div class="grid">
        <div class="cell is-col-span-2 is-flex">
          <DashboardStatues :is-uninvoiced-jobs-and-chart-disabled="isUninvoicedJobsAndChartDisabled"
            :data-obj="defaultDataObj" />
        </div>

        <div v-if="showDashboardInsurerMessages"
          class="cell is-flex is-flex-direction-column is-flex-grow-1">
          <DashboardInsurerMessages class="is-flex-grow-1"
            :is-uninvoiced-jobs-and-chart-disabled="isUninvoicedJobsAndChartDisabled" />
        </div>
        <div class="cell is-flex is-flex-direction-column is-flex-grow-1"
          :class="{'is-col-span-2': !showDashboardInsurerMessages}">
          <DashboardIncomingMessages class="is-flex-grow-1"
            :is-uninvoiced-jobs-and-chart-disabled="isUninvoicedJobsAndChartDisabled" />
        </div>
      </div>
    </div>

    <div class="fixed-grid has-12-cols">
      <div class="grid">
        <div v-if="!isUninvoicedJobsAndChartDisabled"
          class="cell is-col-span-9">
          <div class="grid has-2-cols">
            <div class="cell is-flex is-flex-direction-column is-flex-grow-1">
              <DashboardUnInvoicedJobs class="is-flex-grow-1"
                :default-data-obj="defaultDataObj" />
            </div>
            <div class="cell">
              <DashboardTotalJobs />
            </div>
          </div>
        </div>
        <div class="cell"
          :class="isUninvoicedJobsAndChartDisabled ? 'is-col-span-12' : 'is-col-span-3'">
          <DashboardReleaseNotes />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardIncomingMessages from './DashboardIncomingMessages'
import DashboardUnInvoicedJobs from '@/views/dashboard/DashboardUnInvoicedJobs.vue'
import DashboardTotalJobs from '@/views/dashboard/DashboardTotalJobs.vue'
import DashboardStatues from '@/views/dashboard/DashboardStatues.vue'
import DashboardService from '@/views/dashboard/DashboardService'
import Guid from '@/components/Guid'
import { Columns } from '@/views/quote/columns'
import DashboardReleaseNotes from '@/views/dashboard/DashboardReleaseNotes.vue'
import DashboardInsurerMessages from './DashboardInsurerMessages.vue'

export default {
  name: 'Dashboard',
  components: {
    DashboardInsurerMessages,
    DashboardStatues,
    DashboardTotalJobs,
    DashboardUnInvoicedJobs,
    DashboardIncomingMessages,
    DashboardReleaseNotes
  },
  data() {
    return {
      incomingMessages: [],
      unInvoicedJobs: null,
      reportData: null,
      isLoading: false,
      isUninvoicedJobsAndChartDisabled: true,
      quotes: null,
      defaultDataObj: {
        dateFrom: '',
        dateTo: '',
        insurerId: Guid.empty(),
        jobNSubStage: [],
        active: 1,
        invoiceStatus: 'B',
        authorisedStatus: 'B',
        quoteType: 'Q',
        sortColumn: Columns[0].name,
        sortOrder: Columns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 50,
        search: '',
        claimsTypeKey: ''
      }
    }
  },
  computed: {
    showDashboardInsurerMessages() {
      return this.$company && this.$company.info && this.$company.info.countryCode !== 'MY'
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    this.$store.watch(
      (state) => {
        return state.appnav
      },
      {
        deep: true
      }
    )
  },
  methods: {
    async getData() {
      this.isLoading = true
      const data = await DashboardService.disableUninvoicedJobsAndJobChartStatus()
      // we set isUninvoicedJobsAndChartDisabled to true when component gets created
      // we update the value when we get the response from the server
      this.isUninvoicedJobsAndChartDisabled = data
      this.isLoading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.dashboard {
  min-height: calc(100vh - 90px);
  overflow-y: hidden !important;
}

#app > div.app-content {
  overflow-y: auto !important;
}
</style>
